/* eslint-disable */
import { store as state } from '../../redux/store';

export const getUserInfo = () => state.getState()?.userInfo?.userInfo;
